import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { BaseFormDialogComponent } from "@hub/common/BaseFormDialogComponent";
import { Constants } from "@hub/common/Constants";
import { Functions } from "@hub/common/Functions";
import {
  eActionState,
  eSearchContactType
} from "@hub/generated/enums";
import {
  ContactCardDto, ContactLoanoutDto,
  SearchContactsOptions
} from "@hub/generated/models";
import { SearchController } from "@hub/generated/services";
import { FormEventService } from "@hub/services/form-event.service";
import { FormService } from "@hub/services/form.service";
import { NotificationService } from "@hub/services/NotificationService";
import { PageLoaderService } from "@hub/services/PageLoader";
import { ConfirmationService } from "primeng/api";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "hub-loanout-dialog",
  templateUrl: "./loanout-dialog.component.html",
  providers: [FormService]
})
export class LoanoutDialogComponent extends BaseFormDialogComponent
  implements OnInit, OnDestroy {
  constructor(
    public fb: FormBuilder,
    public notificationService: NotificationService,
    public formService: FormService,
    public searchController: SearchController,
    public confirmationService: ConfirmationService,
    public formEventService: FormEventService,
    public pageLoaderService: PageLoaderService
  ) {
    super(
      fb,
      formService,
      formEventService,
      notificationService,
      pageLoaderService,
      confirmationService
    );
  }

  @Input()
  id: string = Constants.GUID_EMPTY;
  @Input()
  isNew: boolean;
  @Input()
  formData: any;
  @Input()
  isSuccessAddEdit: boolean = true;
  @Output()
  formUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onSaveLoanout: EventEmitter<ContactLoanoutDto> = new EventEmitter<
    ContactLoanoutDto
  >();
  public isFormEdit: boolean;
  public contactNameSuggestions: ContactCardDto[] = [];

  public ngOnInit() {
    this.onInit();
  }

  public ngOnDestroy() {
    this.onDestroy();
  }

  public formInit(): void {
    //this.pageLoaderService.addPageLoader();
    this.isFormEdit = false;
    this.formService.formEdit(false);

    this.formGroup = this.fb.group({
      id: !this.isNew ? this.formData[0].Id : Constants.GUID_EMPTY,
      recordId: this.id,
      contact: !this.isNew
        ? [
            {
              FullName: this.formData[0].LoanoutName,
              Id: this.formData[0].ContactId
            },
            Validators.compose([Constants.notObject])
          ]
        : ["", Validators.compose([Constants.notObject])],
      active: !this.isNew ? (this.formData[0].IsActive ? true : false) : false,
      taxPayerId: !this.isNew
        ? [this.formData[0].TaxNumber, Validators.required]
        : ["", Validators.required],
      FC: !this.isNew ? (this.formData[0].IsForeign ? true : false) : false,
      isUK: !this.isNew ? (this.formData[0].IsUk ? true : false) : false,
      isAus: !this.isNew ? (this.formData[0].IsAus ? true : false) : false,
      GSTReg: !this.isNew ? (this.formData[0].IsGSTReg ? true : false) : false
    });

    this.formGroup.valueChanges
      .pipe(takeUntil(this.ngInitUnsubscribe))
      .subscribe((x: any) => {
        if (this.isFormEdit === false) {
          this.formService.formEdit(true);
          this.isFormEdit = true;
        }
      });
  }

  public saveActionHandler(e: any): void {
    this.onSaveLoanout.emit(this.getLoanoutFormValues());
    if (this.isSuccessAddEdit) {
      this.displayChange.emit(false);
      this.formUpdated.emit();
      this.hide();
    }
  }

  public onAcceptConfirmationHandler(): void {
    this.hide();
    this.displayChange.emit(false);
  }

  public onCloseInvalidFormHandler(): void {
    this.hide();
    this.pageLoaderService.takePageLoader();
  }

  public formValueChangeHandler(data: any): void {
    this.loanoutsFormValueChangeHandler(data);
  }

  public loanoutsFormValueChangeHandler(data) {
    this.isFormEdit = true;
    this.formService.formEdit(true);
  }

  public getContactsDto(event) {
    let searchParameters: SearchContactsOptions = Functions.GetInstanceSearchContactsOptions(event.query);
    searchParameters.Types = [eSearchContactType.Contact]

    this.searchController
      .SearchContacts(searchParameters)
      .pipe(takeUntil(this.ngInitUnsubscribe))
      .subscribe(data => {
        this.contactNameSuggestions = data;
      });
  }

  public getLoanoutFormValues(): ContactLoanoutDto {
    const val = this.formGroup.value;
    const editLoanout = new ContactLoanoutDto();
    editLoanout.Id = val.id;
    editLoanout.RecordId = val.recordId;
    editLoanout.ContactId = val.contact.Id;
    editLoanout.ContactLoanoutId = !this.isNew
      ? this.formData[0].ContactLoanoutId
      : Constants.GUID_EMPTY;
    editLoanout.LoanoutName = val.contact.Value;
    editLoanout.TaxNumber = val.taxPayerId;
    editLoanout.IsActive = val.active;
    editLoanout.IsAus = val.isAus;
    editLoanout.IsUk = val.isUK;
    editLoanout.IsForeign = val.FC;
    editLoanout.IsGSTReg = val.GSTReg;
    editLoanout.ActionState = !this.isNew
      ? eActionState.Changed
      : eActionState.Inserted;
    return editLoanout;
  }
}
